import {
  GET_LOGISTICS_INFO,
  GET_LOGISTICS_INFO_ERROR
} from "../constants/LogisticsConstants";

const INITIAL_STATE = {
  logisticsInfo: null,
  loading: true
};
const logisticsReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_LOGISTICS_INFO:
      return {
        ...state,
        logisticsInfo: action.payload,
        loading: false
      };
    case GET_LOGISTICS_INFO_ERROR:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};

export default logisticsReducer;
